import React, { useState, useContext, useEffect } from 'react'

import Select from 'react-select'
import SelectStyles from '../../../../elem/form/SelectStyles'
import { APIRequestContext } from '../../../../wrappers/APIRequestContext'
import { DataContext } from '../../DataContext'
import WithConfig from '../../../../wrappers/withConfig'
import FacilityInformation from './FacilityInformation'

const ExistingSearchComponent = WithConfig(
    ({
        config,
        facilityData,
        setFacilityData,
        continueDisabled,
        facilityChanged,
        setFacilityChanged,
        uploadConfig,
        isNew,
    }) => {
        const { authenticatedFetch } = useContext(APIRequestContext)
        const { formType, activeAgency, viewOnly } = useContext(DataContext)
        const [valuesChanged, setValuesChanged] = useState(false)
        const [error, setError] = useState()
        const { API_URL } = config
        const [targetField, setTargetField] = useState('StationCode')
        const [facilityIdentifierValue, setFacilityIdentifierValue] =
            useState('')
        const [loading, setLoading] = useState(false)

        useEffect(() => {
            if (facilityIdentifierValue !== '' && !valuesChanged) {
                setFacilityChanged(false)
            } else {
                setFacilityChanged(true)
                //clear errors if project changes
                setError(null)
            }
        }, [valuesChanged, facilityIdentifierValue, targetField])

        const search = (v, field) => {
            setLoading(true)
            setFacilityData(null)
            authenticatedFetch(
                `${API_URL}/upload/${formType.APILink}/${formType.APILink}Info?columnName=${field}&columnValue=${v}&isNew=${isNew}&formType=${formType.FormType}`
            )
                .then(async (response) => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        const error = await response.text()
                        throw new Error(error)
                    }
                })
                .then((response) => {
                    setFacilityData(response.facilityInfo)
                    setError(null)
                    setValuesChanged(false)
                })
                .catch((e) => {
                    setError(e.message)
                    setFacilityData(null)
                })
                .finally(() => setLoading(false))
        }

        return (
            <>
                <div className="columns">
                    <div className="column is-4">
                        <div className="field is-horizontal is-align-items-center">
                            <div className="field-label">
                                <label className="label">{`Identify ${formType.NewlyCreatedIDName || formType.Name} By:`}</label>
                            </div>
                            <div className="field-body">
                                <div className="field is-grouped">
                                    <Select
                                        className="select is-multiple is-fullwidth reactSelect"
                                        classNamePrefix="reactSelect"
                                        defaultValue={[
                                            {
                                                value: 'StationCode',
                                                label: 'Station Code',
                                            },
                                        ]}
                                        options={[
                                            {
                                                value: 'StationCode',
                                                label: 'Station Code',
                                            },
                                        ]}
                                        styles={SelectStyles}
                                        menuPlacement="auto"
                                        name="IdentifierValue"
                                        onChange={(data) => {
                                            setValuesChanged(true)
                                            setTargetField(data.value)
                                            setFacilityIdentifierValue('')
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="column is-7">
                        <div className="field is-horizontal field-body field control">
                            <input
                                className={`input is-fullwidth`}
                                name={'facilityInfo'}
                                type="text"
                                value={facilityIdentifierValue}
                                onChange={(e) => {
                                    setValuesChanged(true)
                                    setFacilityIdentifierValue(e.target.value)
                                }}
                            />
                        </div>
                    </div>
                    <div className="column is-1 is-justify-content-end">
                        <button
                            type="button"
                            disabled={!facilityIdentifierValue}
                            className={`button is-primary ${loading ? 'is-loading' : ''}`}
                            onClick={() =>
                                search(facilityIdentifierValue, targetField)
                            }
                        >
                            Search
                        </button>
                    </div>
                </div>
                {error ? (
                    <div className="has-text-centered has-text-danger">
                        {error}
                    </div>
                ) : (
                    <div className="column is-12">
                        <div className="columns is-centered">
                            <div className="column is-10">
                                <FacilityInformation
                                    formType={formType}
                                    facilityData={facilityData}
                                    continueDisabled={continueDisabled}
                                    viewOnly={viewOnly}
                                    uploadConfig={uploadConfig}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </>
        )
    }
)

export default ExistingSearchComponent
